import { saveAs } from "file-saver";
import { downloadBillRoute } from "@api-routes/billing";
import { useFetch } from "@common/hook/useFetch";

interface IParams {
    billNumber: number;
    accountId: string;
}

export const useDownloadBill = (props: IParams) => {
    const { billNumber, accountId } = props;
    const [downloadBillState, { get }] = useFetch();

    const downloadBill = () => {
        get<Blob>(downloadBillRoute(billNumber, accountId)).then((blob) => {
            if (blob) {
                saveAs(blob, `${billNumber}_bill.pdf`);
            }
        });
    };

    return { downloadBill, downloadBillState };
};
